import { withAuth } from 'hocs/withAuth'
import { withAuthServerSideProps } from 'hocs/withAuth/withAuthServerSideProps'
import dynamic from 'next/dynamic'

const TermsPage = dynamic(() =>
  import('containers/PublicPages/TermsPage').then((res) => res.TermsPage)
)

export default withAuth(TermsPage, {
  LoggedOutComponent: TermsPage,
  naiveCheck: true,
})
export const getStaticProps = withAuthServerSideProps()
